import request from "../utils/request"

export function fetchPetTypeTree() {
  return request({
    url: "/pet-types/admin/tree",
    method: "get"
  })
}

export function fetchPetTypeDetail(typeCode) {
  return request({
    url: `/pet-types/admin/${typeCode}`,
    method: "get"
  })
}

export function createPetType(data) {
  return request({
    url: "/pet-types/admin",
    method: "post",
    data
  })
}

export function updatePetType(typeCode, data) {
  return request({
    url: `/pet-types/admin/${typeCode}`,
    method: "put",
    data
  })
}

export function deletePetType(typeCode) {
  return request({
    url: `/pet-types/admin/${typeCode}`,
    method: "delete"
  })
}

export function uploadPetTypeImage(file) {
  const data = new FormData()
  data.append("file", file)
  return request({
    url: "/pet-types/admin/image/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
